/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { resetForm } from '@insticator/insticator-ui';
import { setFormEditableState, discardChanges, invalidateForm } from '@insticator/insticator-ui';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { savePaymentInformationWithValidation, updatePaymentInformationWithValidation, getPaymentInformation, changePaymentType } from 'state/actions/accountState/account_data';
import { displayModal } from '@insticator/insticator-ui'; // iui-state
// component
import EnterInformation from 'pages/dashboard/account/paymentinfo/enterinformation/enterinformation';



/* ========== ~~~~~~~~~~ ACCOUNT ENTER INFORMATION : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus, appStatus }) => ({
    fields: accountData[accountData.selectedPaymentType].fields,
    formData: accountData[accountData.selectedPaymentType],
    savingData: accountData[accountData.selectedPaymentType].savingData,
    editable: accountData[accountData.selectedPaymentType].editable,
    hasStoredData: Object.keys(accountData[accountData.selectedPaymentType].storedData).length > 0,
    preferredPaymentUpdated: accountData.preferredPaymentUpdated,
    formName: accountData.selectedPaymentType,
    selectedPaymentType: accountData.selectedPaymentType,
    preferredPaymentType: accountData.preferredPaymentType,
    payoutThreshold: accountData.payoutThreshold,
    previousPage: appStatus.previousPage,
    paymentUUID: accountData.paymentUUID,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID, successAction, failAction ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID, successAction, failAction)),
    updatePaymentInformationWithValidation: ( data, paymentType, fields, paymentUUID, successAction, failAction ) => dispatch(updatePaymentInformationWithValidation(fields, data, paymentType, paymentUUID, successAction, failAction)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    changePaymentType: (paymentType) => dispatch(changePaymentType(paymentType)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    invalidateForm: (formName) => dispatch(invalidateForm(formName))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EnterInformation);
